import type { FC } from 'react'

import { Image } from '@skytech/ui/Image'
import { useNavigate } from 'react-router-dom'

import Highlight from '@/components/Highlight'
import type { DeviceApplication } from '@/modules/applications/device/types'
import { APP_ROUTES } from '@/util/app-routes'
import { numberFormat } from '@/util/formatters/numbers'

import './DeviceApplicationListItem.styles.scss'

const Thumbnail: FC<{ order: DeviceApplication }> = ({ order }) => {
  const imgList = order.imgUrls?.split(',') || []

  return (
    <div className="device-application-list__items__item__images">
      {imgList.length > 0 && imgList[0].trim() && <Image src={imgList[0]} alt={order.model} />}
    </div>
  )
}

const DeviceApplicationListItem: FC<{
  searchFilter: string
  order: DeviceApplication
  showStatus: boolean
}> = ({ order, searchFilter, showStatus }) => {
  const navigate = useNavigate()

  const isLeasing = Boolean(order.leasingDurationMonths)
  const totalAmount = isLeasing ? order.totalLeasingAmount : order.totalAmount

  return (
    <div
      role="button"
      tabIndex={0}
      className="device-application-list__items__item"
      onClick={() => navigate(APP_ROUTES.DEVICE_ORDER.replace(':id', String(order.id)))}
      onKeyDown={() => navigate(APP_ROUTES.DEVICE_ORDER.replace(':id', String(order.id)))}
    >
      <div className="details">
        <Thumbnail order={order} />

        <div className="device-application-list__items__item__text">
          <div className="device-application-list__item__text__name">
            <Highlight pattern={searchFilter} text={order.name} />
          </div>

          <div className="device-application-list__items__item__text__model">
            <Highlight pattern={searchFilter} text={order.model} />
          </div>

          <div className="device-application-list__items__item__text__cost">
            {numberFormat(totalAmount - order.remainderAmount)},-
          </div>

          {showStatus && (
            <div className="device-application-list__items__item__text__options">
              <div className={`device-application-status status-${order.status}`} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default DeviceApplicationListItem
